var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinija(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "PRINT",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-952.173 867.644 1652.516 86.743",
    enableBackground: "new -952.173 867.644 1652.516 86.743",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -945.602,
    y: 885.017,
    fill: "#1D63A5",
    width: 1639.389,
    height: 11.402
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "#0F4D81",
    points: "307.212,934.58 273,900.368 273,934.573 307.212,934.573  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#0F4D81",
    points: "614.956,934.58 580.744,900.368 580.744,934.573 614.956,934.573  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#6087BE",
    points: "654.837,900.368 620.625,934.58 654.834,934.58 654.834,900.368  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#0F4D81",
    points: "426.868,900.368 461.08,934.58 461.08,900.368 426.868,900.368  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D63A5",
    d: "M312.885,934.58h68.425c0-18.899-15.316-34.213-34.212-34.213 C328.199,900.368,312.885,915.681,312.885,934.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6087BE",
    d: "M535.182,900.368h-68.425c0,18.9,15.316,34.213,34.212,34.213 C519.868,934.58,535.182,919.267,535.182,900.368z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6087BE",
    d: "M267.324,934.58c0-18.899-15.317-34.213-34.213-34.213v34.213H267.324z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6087BE",
    d: "M421.195,900.354c-18.892,0-34.213,15.312-34.213,34.212h34.213V900.354z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D63A5",
    d: "M694.726,900.354c-18.895,0-34.212,15.312-34.212,34.212h34.212V900.354z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D63A5",
    d: "M540.855,900.368c0,18.892,15.316,34.213,34.212,34.213v-34.213H540.855z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinija);
export default __webpack_public_path__ + "static/media/linija.49cce22dce68e5494a7b0765c2c0eb05.svg";
export { ForwardRef as ReactComponent };